import { legacyCredentialRedirect } from '@/auth/credentialLinks'

export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/send/email/',
    name: 'auth-send-email',
    component: () => import('@/views/pages/authentication/SendConfirmationEmail.vue'),
    meta: {
      credentialPage: true,
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/email/send/',
    name: 'logged-send-email',
    component: () => import('@/views/pages/authentication/LoggedSendConfirmationEmail.vue'),
    meta: {
      credentialPage: true,
      resource: 'SendConfirmationEmail',
      action: 'read',
    },
  },
  {
    path: '/invoice/get/:token',
    name: 'logged-get-invoice',
    component: () => import('@/views/pages/authentication/LoggedGetInvoice.vue'),
    meta: {
      resource: 'GetInvoice',
      action: 'read',
    },
  },
  {
    path: '/get/invoice/:token',
    name: 'auth-get-invoice',
    component: () => import('@/views/pages/authentication/GetInvoice.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      redirectIfLoggedInGetInvoice: true,
    },
  },
  {
    path: '/verify-email',
    name: 'auth-verify-email',
    component: () => import('@/views/pages/authentication/VerifyEmail.vue'),
    meta: {
      credentialPage: true,
      layout: 'full',
      resource: 'Auth',
      public: true,
    },
  },
  {
    path: '/verify/email/:token',
    name: 'auth-verify-email-legacy',
    redirect: to => legacyCredentialRedirect(to, 'auth-verify-email'),
  },
  {
    path: '/email/verification/:token',
    name: 'logged-verify-email',
    redirect: to => legacyCredentialRedirect(to, 'auth-verify-email'),
  },
  {
    path: '/email/:token',
    name: 'logged-verify-email-legacy',
    redirect: to => legacyCredentialRedirect(to, 'auth-verify-email'),
  },
  {
    path: '/agenda/:id',
    name: 'auth-agenda',
    component: () => import('@/views/apps/calendarpublic/Calendar.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      credentialPage: true,
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/mentions-legales',
    name: 'mentions-legales',
    component: () => import('@/views/pages/legal/MentionsLegales.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      public: true,
    },
  },
  {
    path: '/privacy-policy-and-conditions',
    name: 'privacy-policy-and-conditions',
    component: () => import('@/views/pages/legal/PrivacyPolicyAndConditions.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      public: true,
    },
  },
  {
    path: '/role',
    name: 'auth-role',
    component: () => import('@/views/pages/authentication/RegisterRole.vue'),
    meta: {
      credentialPage: true,
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/registerfinal',
    name: 'auth-register-final',
    component: () => import('@/views/pages/authentication/RegisterFinal.vue'),
    meta: {
      credentialPage: true,
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/registerfinal-legacy',
    name: 'auth-register-final-legacy',
    component: () => import('@/views/pages/authentication/RegisterFinalVue2.vue'),
    meta: {
      credentialPage: true,
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  /*{
    path: '/registerfinaltemp',
    name: 'auth-register-final-temp',
    component: () => import('@/views/pages/authentication/RegisterFinal.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },*/
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/pages/authentication/Register.vue'),
    meta: {
      credentialPage: true,
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      credentialPage: true,
      layout: 'full',
      resource: 'Auth',
      public: true,
    },
  },
  {
    path: '/email-change/confirm',
    name: 'auth-email-change-confirm',
    component: () => import('@/views/pages/authentication/EmailChangeConfirm.vue'),
    meta: {
      credentialPage: true,
      layout: 'full',
      resource: 'Auth',
      public: true,
    },
  },
  {
    path: '/reset-password',
    name: 'auth-reset-password',
    component: () => import('@/views/pages/authentication/ResetPassword.vue'),
    meta: {
      credentialPage: true,
      layout: 'full',
      resource: 'Auth',
      public: true,
    },
  },
  {
    path: '/reset-password/:token',
    name: 'auth-reset-password-legacy',
    redirect: to => legacyCredentialRedirect(to, 'auth-reset-password'),
  },
  {
    path: '/pages/miscellaneous/coming-soon',
    name: 'misc-coming-soon',
    component: () => import('@/views/pages/miscellaneous/ComingSoon.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/pages/miscellaneous/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('@/views/pages/miscellaneous/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/payerror',
    name: 'payment-error',
    component: () => import('@/views/pages/miscellaneous/PaymentError.vue'),
    meta: {
      redirectIfLoggedIn: true,
      resource: 'Auth',
      action: 'read',
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/error',
    name: 'misc-error',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/account-setting',
    name: 'pages-account-setting',
    component: () => import('@/views/pages/account-setting/AccountSetting.vue'),
    meta: {
      resource: 'AccountSettings',
      action: 'read',
      pageTitle: 'Account Settings',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Account Settings',
          active: true,
        },
      ],
    },
  },
  /*{
    path: '/pages/profile',
    name: 'pages-profile',
    component: () => import('@/views/pages/profile/Profile.vue'),
    meta: {
      pageTitle: 'Profile',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Profile',
          active: true,
        },
      ],
    },
  },*/
  /*{
    path: '/pages/faq',
    name: 'pages-faq',
    component: () => import('@/views/pages/faq/Faq.vue'),
    meta: {
      pageTitle: 'FAQ',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
    },
  },*/
  /*{
    path: '/pages/knowledge-base',
    name: 'pages-knowledge-base',
    component: () => import('@/views/pages/Knowledge-base/KnowledgeBase.vue'),
    meta: {
      pageTitle: 'Knowledge Base',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/knowledge-base/:category',
    name: 'pages-knowledge-base-category',
    component: () => import('@/views/pages/Knowledge-base/KnowledgeBaseCategory.vue'),
    meta: {
      pageTitle: 'Category',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          to: '/pages/Knowledge-base',
        },
        {
          text: 'Category',
          active: true,
        },
      ],
      navActiveLink: 'pages-knowledge-base',
    },
  },
  {
    path: '/pages/knowledge-base/:category/:slug',
    name: 'pages-knowledge-base-question',
    component: () => import('@/views/pages/Knowledge-base/KnowledgeBaseCategoryQuestion.vue'),
    meta: {
      pageTitle: 'Question',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          to: '/pages/Knowledge-base',
        },
        {
          text: 'Category',
          to: '/pages/Knowledge-base/category',
        },
        {
          text: 'Question',
          active: true,
        },
      ],
      navActiveLink: 'pages-knowledge-base',
    },
  },*/
  {
    path: '/pages/sms-update',
    name: 'pages-sms-update',
    component: () => import('@/views/pages/account-setting/AccountSettingSMSCreditWindowVue2.vue'),
    meta: {
      layout: 'full',
      resource: 'SMSPaymentPage',
      action: 'read',
    },
  },
  {
    path: '/pages/pricing-change',
    name: 'pages-pricing-change',
    component: () => import('@/views/pages/pricing/PricingChangePlanVue2.vue'),
    meta: {
      layout: 'full',
      resource: 'PricingChangePlan',
      action: 'read',
    },
  },
  {
    path: '/pricing',
    name: 'auth-pricing',
    component: () => import('@/views/pages/pricingregister/Pricing.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/share/feedbackclientmeeting/:id',
    name: 'auth-feedback-client-meeting',
    component: () => import('@/views/pages/feedback-client-meeting/PublicFeedbackClientMeeting.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      redirectIfLoggedInFeedbackClient: true,
    },
  },
  {
    path: '/share/anamnesis/:token',
    name: 'auth-anamnesis-share',
    component: () => import('@/views/pages/anamnesis-share/PublicAnamnesisShare.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      redirectIfLoggedInAnamnesisShare: true,
    },
  },
  {
    path: '/feedbackclientmeeting/share/:id',
    name: 'logged-feedback-client-meeting',
    component: () => import('@/views/pages/feedback-client-meeting/LoggedFeedbackClientMeeting.vue'),
    meta: {
      resource: 'FeedbackClientMeeting',
      action: 'read',
    },
  },
  {
    path: '/anamnesis/share/:token',
    name: 'logged-anamnesis-share',
    component: () => import('@/views/pages/anamnesis-share/LoggedAnamnesisShare.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
    },
  },
  /*{
    path: '/pages/pricing',
    name: 'pages-pricing',
    component: () => import('@/views/pages/pricing/Pricing.vue'),
    meta: {
      resource: 'Pricing',
      action: 'read',
    },
  },*/
  /*{
    path: '/pages/pricing-change',
    name: 'pages-pricing-change',
    component: () => import('@/views/pages/pricing/PricingChangePlan.vue'),
    meta: {
      resource: 'PricingChangePlan',
      action: 'read',
    },
  },*/
  /*{
    path: '/pages/blog/list',
    name: 'pages-blog-list',
    component: () => import('@/views/pages/blog/BlogList.vue'),
    meta: {
      pageTitle: 'Blog List',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Blog',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/blog/:id',
    name: 'pages-blog-detail',
    component: () => import('@/views/pages/blog/BlogDetail.vue'),
    meta: {
      pageTitle: 'Blog Detail',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Blog',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/blog/edit/:id',
    name: 'pages-blog-edit',
    component: () => import('@/views/pages/blog/BlogEdit.vue'),
    meta: {
      pageTitle: 'Blog Edit',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Blog',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },*/
]
